// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__4kf-9","LogoBaseline":"Logo_LogoBaseline__K4V7x","LogoSize":"Logo_LogoSize__TNXYO"};